module.exports = __webpack_public_path__ + "img/wa-rune.d22752ca.png";